import { isMobile } from '../../../../core/helpers/isMobile';
import { ColumnsType } from '../../../../core/constants/columnsType';
import { popupStore } from '../../../../store/popupStore';
import { PopupTypes } from '../../../../core/constants/popupTypes';
import { TranslationKeys } from '../../../../core/constants/translationKeys';
import { isPG, isTopC } from '../../../../core/helpers/skinHelper';
import { cryptoCurrencies } from '../../../../core/constants/cryptoCurrencies';
import { userInfoStore } from '../../../../store/userInfoStore';

export const BLACK_JACK_GAME_ID = 39;

export const ACTION_TYPE = {
  0: 'MAIN_BET',
  1: 'SPLIT',
  2: 'DOUBLE',
  3: 'INSURANCE',
};

export const BlackJackGameMode = {
  Normal: 0,
  Turbo: 1,
};

export const SOCKET_DECISIONS_METHODS = [
  'SplitResult',
  'StandResult',
  'HitResult',
  'DoubleResult',
  'InsuranceResult',
  'InsuranceInfoResult',
];

export const DECISION_RESULT_EVENTS = {
  HitResult: 'HitResult',
  StandResult: 'StandResult',
  SplitResult: 'SplitResult',
  DoubleResult: 'DoubleResult',
  InsuranceResult: 'InsuranceResult',
  InsuranceInfoResult: 'InsuranceInfoResult',
};

export const SOCKET_INVOKE_TARGETS = {
  0: 'Hit',
  1: 'Stand',
  2: 'Double',
  3: 'Split',
  4: 'Insurance',
  5: 'NoInsurance',
};

export const INSURANCE_TYPE = 5;

export const DARK_CARD_STATUS = 0;

export const PUSH_STATE_ODD = 1;

export const CARD_OWNER = {
  Dealer: 1,
  USER: 2,
};

export const BLACK_JACK_TEXT = 'BJ';
export const INSURANCE_ACTION_TYPE = {
  YES: 4,
  NO: 5,
};

export const BLACK_JACK_POINT = 21;

export const SPLIT_HAND_TYPE = 1;
export const MAIN_HAND_TYPE = 0;

export const BlackJackHandNameByType = {
  0: 'main',
  1: 'split',
};

export const DECISIONS_MODELS = [
  { type: 0, name: 'HIT', iconName: 'icon-plus cpt-plus', className: 'green', isBet: false },
  { type: 1, name: 'STAND', iconName: 'icon-stand cpt-stand', className: 'red', isBet: false },
  { type: 3, name: 'SPLIT', iconName: 'icon-split cpt-split', className: 'blue', isBet: true },
  { type: 2, name: 'DOUBLE', iconName: 'icon-double cpt-double', className: 'yellow', isBet: true },
];
export const SOCKET_METHODS = {
  DECISION_RESULT: 'DecisionResult',
  SHUFFLE_CARDS: 'ShuffleCards',
  CARD_RESULT: 'CardResult',
  SPIN_RESULT: 'SpinResult',
  AUTO_STAND_RESULT: 'AutoStandResult',
  INSURANCE: 'Insurance',
};

export const DECISION_TYPE = {
  hit: 0,
  stand: 1,
  double: 2,
  split: 3,
};

export const BlackJackLiveBetsColumns = [
  {
    title: TranslationKeys.UserId,
    dataKey: 'userId',
    isShow: true,
    columnType: ColumnsType.MaskNameFormat,
  },
  {
    title: TranslationKeys.Time,
    dataKey: 'date',
    columnType: ColumnsType.DateFormat,
    isShow: !isMobile(),
  },
  {
    title: isMobile() ? TranslationKeys.Bet : TranslationKeys.BetAmount,
    dataKey: 'amount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
  {
    title: TranslationKeys.Odds,
    dataKey: 'odd',
    isShow: true,
    columnType: ColumnsType.Default,
    additionalInfoRenderer: () => 'x',
  },
  {
    title: TranslationKeys.Payout,
    dataKey: 'winAmount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
];

export const BlackJackBetHistoryColumns = [
  {
    title: TranslationKeys.BetId,
    dataKey: 'spinId',
    isShow: true,
    columnType: ColumnsType.Default,
    colRenderer: (spinInfo) => (
      <i
        onClick={(e) => {
          e.stopPropagation();
          popupStore.open({
            name: PopupTypes.Fairness,
            spinInfo: { ...spinInfo, id: spinInfo.spinId },
          });
        }}
        className='icon-fairness-fill cpt-table-column-icon'
      />
    ),
  },
  {
    title: TranslationKeys.Time,
    dataKey: 'date',
    columnType: ColumnsType.DateFormat,
    isShow: !isMobile(),
  },
  {
    title: isMobile() ? TranslationKeys.Bet : TranslationKeys.BetAmount,
    dataKey: 'amount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
  {
    title: TranslationKeys.Actions,
    dataKey: '',
    isShow: !isMobile(),
    columnType: ColumnsType.Default,
    additionalInfoRenderer: (spinInfo, t) => t(ACTION_TYPE[spinInfo.type]),
  },
  {
    title: TranslationKeys.Odds,
    dataKey: 'odd',
    isShow: true,
    columnType: ColumnsType.Default,
    additionalInfoRenderer: () => 'x',
  },
  {
    title: TranslationKeys.Payout,
    dataKey: 'winAmount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
];

export const BLACK_JACK_RULES_KEYS = new Array(isPG() ? 36 : 14)
  .fill(null)
  .map((item, index) => index + 1);
export const BLACK_JACK_ABOUT_HASH_KEYS = new Array(16).fill(null).map((item, index) => index + 1);
